import { useCallback, useState } from 'react';

import {
  GetInteractionRoomRoomIdStatusOptions,
  GetInteractionRoomRoomIdStatusFields,
} from '@vimeo/gctl-api/fetchers/interaction_room/room_id/status';
import { useGetInteractionRoomRoomIdStatus } from '@vimeo/gctl-api/hooks/useInteractionRoomRoomIdStatus';
import { interactionToolsConfig } from '@vimeo/live-core/configs/InteractionToolsConfig';
import { EComposerSessionType, TComposerSessionId } from '@vimeo/live-core/types/composer_session';

type TRoomType = EComposerSessionType.LIVE_EVENT | EComposerSessionType.VENUE;

interface IUseInteractionToolsStatusProps {
  isActive: boolean;
  sessionType: EComposerSessionType;
  sessionId: TComposerSessionId;
}

export function useInteractionToolsStatus({
  isActive,
  sessionId,
  sessionType,
}: IUseInteractionToolsStatusProps) {
  const [isEnabled, setEnabled] = useState<boolean>(false);

  const getPollingOptions = useCallback(() => {
    if (isActive) {
      return {
        where: {
          roomType: sessionType as TRoomType,
          roomId: sessionId as string,
        },
        select: ['status.enabled'],
      } as GetInteractionRoomRoomIdStatusOptions<GetInteractionRoomRoomIdStatusFields>;
    }

    return null;
  }, [isActive, sessionId, sessionType]);

  useGetInteractionRoomRoomIdStatus(getPollingOptions, {
    refreshInterval: interactionToolsConfig.INTERACTION_ROOM_STATUS_POLLING_INTERVAL,
    refreshWhenHidden: true,
    onSuccess: (data) => {
      if (!data || !data.hasOwnProperty('status') || !data.status.hasOwnProperty('enabled')) {
        return;
      }

      if (data.status.enabled !== isEnabled) {
        setEnabled(data.status.enabled);
      }
    },
  });

  return isEnabled;
}
